import { Box, Typography } from "@mui/material";
import React from "react";
import DealsEmptyDocumentsIcon from "./icons/dealsEmptyDocumentsIcon";

type Props = {
  icon?: React.ReactNode;
  text: string;
};

const PageEmptyStateMessage = ({ icon, text }: Props) => {
  return (
    <Box>
      <Box display="flex" flexDirection="row" alignItems="center">
        <Box>{icon ? icon : <DealsEmptyDocumentsIcon />}</Box>
        <Box marginLeft="10px">
          <Typography>{text}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default PageEmptyStateMessage;
